import React from 'react';

const rotationMap = {
  down: 0,
  left: 90,
  up: 180,
  right: 270,
};

const ChevronIcon = ({ direction = 'down', size = 20, className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    className={className}
    style={{ transform: `rotate(${rotationMap[direction]}deg)` }}
  >
    <path
      d="M5 7.5L10 12.5L15 7.5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ChevronIcon;
